import {AddWith2ParamsOptions} from '../../../../components/grid-dx/types';
import authFetch from '../../../../helpers/requests';
import {useSelector} from 'react-redux';

function useAddWith2ParamsOptions(url: string, additional: string | null) {
  const token: string = useSelector(
    (state: any) => state.authentication.user.token,
  );
  return async (addWith2ParamsOptions: AddWith2ParamsOptions) => {
    let options = new URLSearchParams();
    options.append('id_Course', JSON.stringify(addWith2ParamsOptions.AddedTwo));
    options.append(
      'credential',
      JSON.stringify(addWith2ParamsOptions.AddedThree),
    );
    if (additional != null) options.append('mode', additional);
    try {
      const response = await authFetch(
        `${url}?${options}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify(JSON.stringify(addWith2ParamsOptions.AddedOne)),
        },
        token,
      );
      return response;
    } catch (e) {
      return console.error(e); //Que hacemos aca?
    }
  };
}

export default useAddWith2ParamsOptions;
